var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MessageView',{attrs:{"title":"Could Not Fetch Issues","message":"There was a problem retrieving the sensor issues."}})}
var staticRenderFns = []

export { render, staticRenderFns }